import { render, staticRenderFns } from "./select-estados.vue?vue&type=template&id=3e5ec577"
import script from "./select-estados.vue?vue&type=script&lang=ts"
export * from "./select-estados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports